import { makeStyles } from '@material-ui/core'
import { colors } from '../../../Themes'

const useStylesTextInput = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignSelf: 'stretch',
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '30ch',
  },
  input: {
    flexGrow: 1,
    borderWidth: 10,
    borderColor: colors.accent,
    marginTop: 15,
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
      marginBottom: 8,
    },
  },
}))
  
const textInputStyles = {
  root: {
    borderRadius: 5,
    color: colors.primary,
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: 18,
    backgroundColor: colors.background,
    '&:hover': {
      backgroundColor: colors.backgroundHover,
    },
    '&$focused': {
      backgroundColor: colors.background,
    },
    '&$disabled': {
      color: colors.primaryRGBA(0.5),
      fontFamily: 'Roboto',
      fontWeight: 400,
      fontSize: 18,
      backgroundColor: colors.background,
    },
    '& .MuiFilledInput-inputHiddenLabel': {
      paddingTop: '19px !important'
    },
  },
    
  underline: {
    '&:after': {
      border: '1px solid ' + colors.primary,
      top: 0,
      borderRadius: 5,
      transform: 'scaleX(1)',
      opacity: 0,
    },
    '&$focused:after': {
      transform: 'scaleX(1)',
      opacity: 1,
    },
    '&:before': {
      borderWidth: 0,
    },
    '&:hover:before': {
      borderWidth: 0,
      pointerEvents: 'none',
    },
    '&$disabled:before': {
      borderWidth: 0,
      pointerEvents: 'none',
    },
  },
  focused: {},
  disabled: {},
}
  
export { textInputStyles, useStylesTextInput }